import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminAdmins = z.any()
export type TagsGetAdminAdmins = z.infer<typeof tagsGetAdminAdmins>

export const querystringGetAdminAdmins = z.object({ "page": z.string().optional(), "perPage": z.string().optional() })
export type QuerystringGetAdminAdmins = z.infer<typeof querystringGetAdminAdmins>

export const responseGetAdminAdmins = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "email": z.string().email(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "privileges": z.array(z.string()) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminAdmins = z.infer<typeof responseGetAdminAdmins>

interface IGetAdminAdmins extends BaseMethodType {
  tags: TagsGetAdminAdmins,
  querystring: QuerystringGetAdminAdmins,
  response: ResponseGetAdminAdmins
}
export const tagsPostAdminAdmins = z.any()
export type TagsPostAdminAdmins = z.infer<typeof tagsPostAdminAdmins>

export const bodyPostAdminAdmins = z.object({ "name": z.string().min(1), "email": z.string().email().min(1), "verifiedEmail": z.boolean().optional(), "verifiedByAdmin": z.boolean().optional(), "privileges": z.array(z.string()) })
export type BodyPostAdminAdmins = z.infer<typeof bodyPostAdminAdmins>

export const responsePostAdminAdmins = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "email": z.string().email(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "privileges": z.array(z.string()) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminAdmins = z.infer<typeof responsePostAdminAdmins>

interface IPostAdminAdmins extends BaseMethodType {
  tags: TagsPostAdminAdmins,
  body: BodyPostAdminAdmins,
  response: ResponsePostAdminAdmins
}
export const URL = '/admin/admins'
export const validation = {
  get: {
    tags: tagsGetAdminAdmins,
    querystring: querystringGetAdminAdmins,
    response: responseGetAdminAdmins
  },
  post: {
    tags: tagsPostAdminAdmins,
    body: bodyPostAdminAdmins,
    response: responsePostAdminAdmins
  }
}
export interface AdminAdmins extends BaseRouteType {
  get: IGetAdminAdmins,
  post: IPostAdminAdmins
}